import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

if (window.CONFIG?.isDevelopment) {
  //import { Log } from 'oidc-client-ts';
  //Log.setLogger(console);
  //Log.setLevel(Log.DEBUG);
}

class OidcService {
  constructor() {
    if (!OidcService.instance) {
      const oidc = window.CONFIG?.member?.scope?.oidc;
      if (!oidc) return;
      const settings = {
        authority: oidc.authority,
        client_id: oidc.client_id,
        popup_redirect_uri: `${window.location.origin}/callback-login.html`,
        post_logout_redirect_uri: `${window.location.origin}/callback-logout.html`,
        silent_redirect_uri: `${window.location.origin}/callback-silent.html`,
        response_type: 'code',
        scope: oidc.scope ?? 'openid email',
        automaticSilentRenew: true,
        includeIdTokenInSilentRenew: true,
        monitorSession: true,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        stateStore: new WebStorageStateStore({ store: window.localStorage }),
        clockSkewInSeconds: 60,
      };
      this.userManager = new UserManager(settings);
      OidcService.instance = this;
    }
    return OidcService.instance;
  }

  isValid() {
    return !!this.userManager;
  }

  async getUser() {
    return await this.userManager.getUser();
  }

  async removeUser() {
    await this.userManager.removeUser();
  }

  async login() {
    try {
      await this.userManager.signinPopup();
    } catch (err) {
      console.error('Error during login:', err); // eslint-disable-line no-console
    }
  }

  async loginCallback() {
    try {
      await this.userManager.signinPopupCallback();
    } catch (err) {
      console.error('Error during login callback:', err); // eslint-disable-line no-console
    }
  }

  async loginSilent() {
    try {
      await this.removeUser();
      const user = await this.userManager.signinSilent();
      return user;
    } catch (err) {
      console.error('Error during silent login:', err); // eslint-disable-line no-console
      throw err;
    }
  }

  async loginSilentCallback() {
    try {
      await this.userManager.signinSilentCallback();
    } catch (err) {
      console.error('Error during silent login callback:', err); // eslint-disable-line no-console
    }
  }

  async logout() {
    try {
      await this.userManager.signoutPopup();
      await this.userManager.removeUser();
    } catch (err) {
      console.error('Error during logout:', err); // eslint-disable-line no-console
    }
  }

  async logoutCallback() {
    try {
      await this.userManager.signoutPopupCallback();
    } catch (err) {
      console.error('Error during logout callback:', err); // eslint-disable-line no-console
    }
  }
}

export default new OidcService(); // <- singleton
